/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-10 09:58:13
 */
import React from 'react'
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'

export enum CreditLevel {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low'
}

export interface CreditStandard {
  level: CreditLevel
  title: string
  description: string
  color: string
  icon: React.ReactNode
}

export const CREDIT_STANDARDS: CreditStandard[] = [
  {
    level: CreditLevel.HIGH,
    title: '工作信用高',
    description:
      '拍摄人长期规范使用app，无任何异常拍照行为，工作记录可信度高。',
    color: 'emerald',
    icon: <CheckCircleOutlined style={{ fontSize: '28px', color: '#10b981' }} />
  },
  {
    level: CreditLevel.MEDIUM,
    title: '工作信用中等',
    description:
      '可能是因为软件版本低，或近30天被检测到时间地点异常，或曾有过重度异常行为（违规使用破解包等）。',
    color: 'amber',
    icon: (
      <ExclamationCircleOutlined
        style={{ fontSize: '28px', color: '#f59e0b' }}
      />
    )
  },
  {
    level: CreditLevel.LOW,
    title: '工作信用低',
    description:
      '拍摄人近30天有重度异常行为，比如使用破解版本或修改水印时间地点等，工作记录可信度低。',
    color: 'red',
    icon: (
      <ExclamationCircleOutlined
        style={{ fontSize: '28px', color: '#ef4444' }}
      />
    )
  }
]
